import React, { type ReactNode } from 'react';

import Dotdotdot from 'react-dotdotdot';

import { BodyText } from './styled';

type TruncatedTypeProps = {
	text: ReactNode;
	clamp?: number;
};

export function TruncatedText({ clamp = 2, text }: TruncatedTypeProps) {
	return (
		<Dotdotdot clamp={clamp} useNativeClamp>
			<BodyText>{text}</BodyText>
		</Dotdotdot>
	);
}

export { BodyText };
